import React, { useState, useEffect } from 'react';
import { get } from 'lodash-es';
import { useField } from 'react-form';
import { Checkbox as CheckboxComponent, Box, Label, makeStyles } from '@hummingbirdtechgroup/wings-ui';
import { ValidationMessage } from '../index';
const Checkbox = (props) => {
    const useStyles = makeStyles(() => ({
        root: {
            marginTop: 12,
        }
    }));
    const classes = useStyles();
    return (React.createElement(Box, { className: classes.root, flexDirection: "rowReverse" },
        React.createElement(Label, { htmlFor: props.id, variant: "body2" }, props.label),
        React.createElement(CheckboxComponent, { ...props })));
};
const ControlledCheckbox = (props) => {
    const { field, validations = [] } = props;
    const [checked, setChecked] = useState(false);
    const { meta: { error, isTouched, isValidating }, getInputProps, runValidation, } = useField(field, {
        validate: () => {
            const failingValidation = validations.find(validation => !validation.isValid(checked));
            return get(failingValidation, 'message', false);
        },
    });
    useEffect(() => {
        runValidation();
    }, [checked]);
    const handleChange = () => setChecked(!checked);
    return (React.createElement(React.Fragment, null,
        React.createElement(Checkbox, { ...getInputProps(props), onChange: handleChange, checked: checked }),
        !isValidating && isTouched && error && (React.createElement(ValidationMessage, null, error))));
};
Checkbox.Controlled = ControlledCheckbox;
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map